import * as React from 'react';

export const accordionMaintenance = [
  {
    title: '13 видеоуроков для родителей',
    description:
      <>
        <p>
          Каждый урок содержит методическую и практическую части — вы не только узнаете, как научить ребёнка читать эффективно, но вслед за преподавателем попробуете потренироваться сами. В дополнительных материалах вы найдёте множество игр и упражнений, а также списки литературы. Чтобы облегчить восприятие, мы снабдили уроки схемами, картинками и другими визуальными элементами.
        </p>
        <ul>
          <li>Урок 1. Введение.</li>
          <li>Урок 2. Природный темп деятельности.</li>
          <li>Урок 3. Техника чтения.</li>
          <li>Урок 4. Внимание.</li>
          <li>Урок 5. Память.</li>
          <li>Урок 6. Зрительное восприятие.</li>
          <li>Урок 7. Мышление.</li>
          <li>Урок 8. Артикуляция.</li>
          <li>Урок 9. Скорочтение.</li>
          <li>Урок 10. Понимание и запоминание прочитанного.</li>
          <li>Урок 11. Речь.</li>
          <li>Урок 12. Интерес к чтению.</li>
          <li>Урок 13. Заключение.</li>
        </ul>
      </>
  },
  {
    title: 'Пособие для чтения',
    description:
      <>
        <p>Книга содержит 15 историй с упражнениями и заданиями и 15 уроков с текстами для чтения.</p>
      </>
  },
  {
    title: '225 интерактивных упражнений',
    description:
      <>
        <p>на обучающей платформе. Упражнения разбиты на 15 уроков</p>
      </>
  },
];
